import React from 'react'

const useUserId = () => {
    const userId = localStorage.getItem('user.id') || null
  return userId
}

export default useUserId